import "core-js/modules/es.symbol.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/web.dom-collections.for-each.js";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.object.to-string.js";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { defineStore } from 'pinia';
var useEventsStoreDefinition = defineStore('events', {
  state: function state() {
    return {
      searchTerm: '',
      currentEvent: null,
      organizerId: null
    };
  },
  getters: {
    getSearchTerm: function getSearchTerm(state) {
      return state.searchTerm;
    },
    getCurrentEvent: function getCurrentEvent(state) {
      return state.currentEvent;
    },
    getOrganizerId: function getOrganizerId(state) {
      return state.organizerId;
    }
  },
  actions: {
    setSearchTerm: function setSearchTerm(payload) {
      this.searchTerm = payload;
    },
    setCurrentEvent: function setCurrentEvent(payload) {
      this.currentEvent = _objectSpread(_objectSpread({}, payload), {}, {
        // the number of discounts might get very large and lead to a quota exceed error
        ticketDiscount: [],
        // since descriptions might get very large and lead to a quota exceed error,
        // we do not store them (since we don't need them anyway)
        ticketConfig: payload.ticketConfig.map(function (tc) {
          return _objectSpread(_objectSpread({}, tc), {}, {
            description: undefined
          });
        })
      });
    },
    setOrganizerId: function setOrganizerId(payload) {
      this.organizerId = payload;
    }
  },
  persist: true
});

// VUE 2.7 WORKAROUND — see composables/usePinia.ts. Remove this wrapper at
// the Vue 3 flip and export useEventsStoreDefinition directly as
// useEventsStore instead.
export function useEventsStore() {
  return useEventsStoreDefinition(usePinia());
}